import React from "react";
import itLocale from "@fullcalendar/core/locales/it";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import FullCalendar from "@fullcalendar/react";
import { useSelector } from "react-redux";

const CoreCalendar = ({ events, onOpen, onCreate }) => {
  const colorPrimary = useSelector((state) => state.app.primaryColor);
  const colorSecondary = useSelector((state) => state.app.secondaryColor);

  document.documentElement.style.setProperty("--color-primary", colorPrimary);
  document.documentElement.style.setProperty(
    "--color-secondary",
    colorSecondary
  );

  return (
    <FullCalendar
      selectable
      dateClick={onCreate ? (e) => onCreate(e) : false}
      displayEventTime={false}
      editable
      plugins={[dayGridPlugin, interactionPlugin]}
      initialView="dayGridMonth"
      locale={itLocale}
      eventClick={(e) => onOpen(e)}
      events={events}
      titleFormat={{ year: "numeric", month: "long" }}
    />
  );
};

export default CoreCalendar;
